"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowResize = void 0;
const react_1 = require("react");
const useWindowResize = (handler, { delay = 0 } = {}) => {
    (0, react_1.useEffect)(() => {
        let timeoutID;
        const handleResize = () => {
            clearTimeout(timeoutID);
            timeoutID = setTimeout(handler, delay);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            clearTimeout(timeoutID);
            window.removeEventListener('resize', handleResize);
        };
    }, [delay, handler]);
};
exports.useWindowResize = useWindowResize;
//# sourceMappingURL=index.js.map